import httpStore from "@/api/httpStore.js";

export function getProductStats(sku) {
  return httpStore
    .get(`/statistics/product_sales`, { params: sku ? { sku } : {} })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function getWholeStatistics(fromDate, toDate) {
  return httpStore
    .get(`/statistics/wholesale`, {
      params: {
        from: fromDate,
        to: toDate
      }
    })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
